<template>
  <div class="w12 coin coin-table">
    <div
      class="w12 table-row"
      :class="log.transferType == '입금' ? 'deposit' : 'withdraw'"
      v-for="(log, index) in historyList"
      :key="index"
    >
      <div class="w12" flex fjb fic>
        <div class="w12 type-line" flex>
          <div class="w6 type-color">
            {{
              log.transferType == "입금"
                ? $t("tradeLog.deposit")
                : $t("tradeLog.withdrawal")
            }}
            ({{ logStatus($t(`tradeLog.LogStatus`), log.status) }})
          </div>
          <div class="w6 ta-r">
            {{ log.amount == 0 ? 0 : log.amount }} {{ activeCoin.code }}
          </div>
        </div>
        <div class="w12 date-line" flex>
          <div class="w6">{{ log.date }}</div>
          <div class="w6 ta-r">
            수수료 {{ log.fee == 0 ? 0 : log.fee }} {{ activeCoin.code }}
          </div>
        </div>
        <div class="w12 bold txid mt14t">
          <a
            :href="getTxUrl(activeCoin.code, log.transactionId)"
            target="_blank"
            >{{ log.transactionId || "-" }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Moment from "moment";
export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
    activeCoin: {},
  },
  data() {
    return {
      historyList: [],
      moment: Moment,
    };
  },
  watch: {
    list(newVal, oldVal) {
      this.historyList = newVal;
    },
  },
  methods: {
    logStatus(logString, status) {
      return logString[status];
    },
    getTxUrl(coinId, txid) {
      const url = _.get(this, [
        "$store",
        "getters",
        "coinSettings",
        coinId,
        "trackUrl",
      ]);

      const regex = /^[a-zA-Z0-9+]*$/g;
      if (txid && coinId == "USDT" && txid.length == 64)
        return `https://tronscan.org/#/transaction/${txid}`;
      else if (txid && coinId == "USDT" && txid.length == 66)
        return url.replace("@transaction-id", txid);
      else if (regex.test(txid)) return url.replace("@transaction-id", txid);
      else "";
    },
    setDate(date) {
      console.log(date);
      let list = date.split(" ");
      list[0] = list[0].split("-").join(".");
      list[0] = list[0].slice(2, list[0].length);

      return list;
    },
  },
};
</script>
